import React from 'react';
import PixelButton from '../components/PixelButton';
import { FaTwitter, FaInstagram } from 'react-icons/fa';

const Contact = () => {
    return (
        <div className="min-h-screen flex flex-col bg-[#0E101D]">
            <div className="flex-grow container mx-auto px-4 py-20 mt-10 max-w-4xl">
                <h1 className="text-4xl md:text-5xl font-vt323 text-[#ff0055] mb-2 text-center uppercase tracking-widest">Contact Us</h1>
                <p className="text-xl font-vt323 text-center text-gray-400 mb-12">Have a question? We'd love to hear from you.</p>

                <div className="grid md:grid-cols-2 gap-12">
                    {/* Info Section */}
                    <div className="space-y-8">
                        <div className="bg-[#161823] p-6 border-b-4 border-[#00d0ff]">
                            <h3 className="text-2xl font-vt323 text-white mb-2 uppercase">Email Us</h3>
                            <a href="mailto:nimiologyy@gmail.com" className="text-xl font-vt323 text-gray-300 hover:text-[#00d0ff] transition-colors">nimiologyy@gmail.com</a>
                        </div>

                        <div className="bg-[#161823] p-6 border-b-4 border-[#ffdd00]">
                            <h3 className="text-2xl font-vt323 text-white mb-2 uppercase">Social Media</h3>
                            <p className="text-xl font-vt323 text-gray-300 mb-4">Follow us for updates and features.</p>
                            <div className="flex space-x-4">
                                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-3xl text-white hover:text-[#ffdd00] transition-colors"><FaTwitter /></a>
                                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-3xl text-white hover:text-[#ffdd00] transition-colors"><FaInstagram /></a>
                            </div>
                        </div>

                        <div className="bg-[#161823] p-6 border-b-4 border-[#ff0055]">
                            <h3 className="text-2xl font-vt323 text-white mb-2 uppercase">FAQ</h3>
                            <div className="space-y-4">
                                <div>
                                    <p className="text-[#ff0055] font-vt323 text-xl">Q: How do I change pixel size?</p>
                                    <p className="text-gray-300 font-vt323 text-lg">A: Use the slider on the main camera screen.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Form Section */}
                    <form className="bg-[#161823] p-8 border-4 border-[#2d2d2d] relative">
                        {/* Decorative Pixel Corners */}
                        <div className="absolute top-0 left-0 w-2 h-2 bg-white"></div>
                        <div className="absolute top-0 right-0 w-2 h-2 bg-white"></div>
                        <div className="absolute bottom-0 left-0 w-2 h-2 bg-white"></div>
                        <div className="absolute bottom-0 right-0 w-2 h-2 bg-white"></div>

                        <div className="space-y-6">
                            <div>
                                <label className="block text-[#00d0ff] font-vt323 text-xl uppercase mb-2">Name</label>
                                <input type="text" className="w-full bg-[#0E101D] border-2 border-[#2d2d2d] p-3 text-white font-vt323 text-xl focus:border-[#00d0ff] focus:outline-none transition-colors" placeholder="Retro Fan" />
                            </div>
                            <div>
                                <label className="block text-[#ffdd00] font-vt323 text-xl uppercase mb-2">Email</label>
                                <input type="email" className="w-full bg-[#0E101D] border-2 border-[#2d2d2d] p-3 text-white font-vt323 text-xl focus:border-[#ffdd00] focus:outline-none transition-colors" placeholder="you@pixel.com" />
                            </div>
                            <div>
                                <label className="block text-[#ff0055] font-vt323 text-xl uppercase mb-2">Message</label>
                                <textarea className="w-full bg-[#0E101D] border-2 border-[#2d2d2d] p-3 text-white font-vt323 text-xl focus:border-[#ff0055] focus:outline-none transition-colors h-32" placeholder="Tell us what you think..."></textarea>
                            </div>
                            <PixelButton className="w-full justify-center">Send Message</PixelButton>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;
